export default "__VITE_ASSET__0e67cb2f__"